// extracted by mini-css-extract-plugin
module.exports = {"infoMessage":"R7OI2f1UIbjfeXr3XJ7f"};